'use client'

import { useCallback, useEffect, useState } from 'react'
import { useTranslations } from 'next-intl'
import { userIsLoggedInSelector, useSSO } from '@segway/core'
import { useAppSelector } from '@segway/core/src/store/hooks'

import { AccountIcon } from '@/components'
import { useRouter } from '@/i18n/navigation'

type TLoginPromptProps = {
  text: string
  callbackUrl?: string
}

/**
 * 登录提示
 */
const LoginPrompt = ({ text, callbackUrl }: TLoginPromptProps) => {
  const router = useRouter()
  const t = useTranslations('Cart')

  const isLoggedIn = useAppSelector(userIsLoggedInSelector)

  const [show, setShow] = useState(false)

  const { redirectSignInUrl } = useSSO()

  /**
   * 跳转到 sso 登录页
   */
  const handleRedirectLoginUrl = useCallback(() => {
    redirectSignInUrl(
      callbackUrl ? window.location.origin + callbackUrl : window.location.href,
      router,
    )
  }, [redirectSignInUrl, router, callbackUrl])

  useEffect(() => {
    setShow(!isLoggedIn)
  }, [isLoggedIn])

  if (!show) return null

  return (
    <div className="flex h-11 items-center rounded-md bg-secondary-red-600 px-6 text-black xl:font-miSansRegular330">
      <AccountIcon className="text-gray-3" />
      <button className="mx-[6px] text-gray-3 underline" onClick={handleRedirectLoginUrl}>
        {t('login')}
      </button>
      {text}
    </div>
  )
}

export default LoginPrompt
